import React, { useContext } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CircleStarIcon } from '@/atoms/Icons/CircleStarIcon'
import { AsP, EyebrowSM, EyebrowXS, HeadingXS } from '@/atoms/Text'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { LimitedDateModalContext } from '@/views/TicketCheckoutViews/ShowtimesView/contexts/LimitedDateModalContext'

interface Props {
  eventDate: Date | null
}

export const LimitedDateCard: React.FC<Props> = ({ eventDate }) => {
  const limitedDateModalContext = useContext(LimitedDateModalContext)
  const track = useSafeTrack()
  const { t } = useTranslate('tickets')

  if (!eventDate) return null

  const month = eventDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase()
  const day = eventDate.getDate()

  const handleClick = () => {
    track('Limited Date Card Clicked')
    limitedDateModalContext.openModal()
  }

  return (
    <div
      className="relative h-24 w-[72px] transform-gpu cursor-pointer overflow-hidden rounded-xl border-[1.5px] border-error-600 bg-error-100 transition-transform duration-300 ease-in-out [backface-visibility:hidden] hover:scale-[1.03]"
      onClick={handleClick}
    >
      <FlexColumn className="relative h-full items-center justify-center">
        <CircleStarIcon size={16} className="absolute right-1 top-1" color="error-700" />
        <div className="flex h-full flex-col justify-center p-1 text-center text-error-700">
          <EyebrowSM className="cursor-pointer">{month}</EyebrowSM>
          <HeadingXS as={AsP} weight="bold">
            {day}
          </HeadingXS>
          <EyebrowXS weight="normal" className="cursor-pointer uppercase">
            {t('guildOnlyRedCarpet', 'Guild Only Red Carpet')}
          </EyebrowXS>
        </div>
      </FlexColumn>
    </div>
  )
}
